import { createSelector } from 'reselect';

const selectGlobalSwitches = (state: any) => state.globalSwitches;

export const selectGlobalSwitchesCurrentItem = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.current);

export const selectGlobalSwitchesListItems = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.list);

export const selectGlobalSwitchesItemById = (itemId: any) =>
    createSelector(selectGlobalSwitchesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalSwitchesQueryItems = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.query);

export const selectGlobalSwitchesCreatedItem = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.create);

export const selectGlobalSwitchesUpdatedItem = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.update);

export const selectGlobalSwitchesReadItem = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.read);

export const selectGlobalSwitchesDeletedItem = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.delete);

export const selectGlobalSwitchesSearchedItems = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.search);

export const selectGlobalSwitchesItemsCount = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.count);

export const selectGlobalSwitchesItemsFilter = createSelector([selectGlobalSwitches], (globalSwitches) => globalSwitches.filter);